// Source: app/scripts/controllers/login.js
/**
 * Created by ristes on 20.4.15.
 */

Auction.controller('LoginController', [
  '$scope',
  '$routeParams',
  '$rootScope',
  '$location',
  '$cookieStore',
  '$filter',
  'UserService',
  'Auth',
  'toaster',
  'crudService',
  'Page',
  function ($scope, $routeParams, $rootScope, $location,
            $cookieStore, $filter, UserService, Auth, toaster,
            crudService, Page) {

    var userService = crudService('users', { //
      'checkPasswordExpiration': { //
        method: 'GET', //
        url: '/data/rest/users/check_password_expiration' //
      }
    });


    $scope.response = null;
    $scope.widgetId = null;

    $scope.showCaptcha = true;

    $scope.model = {
//      key: '6LdgoQITAAAAALJEkb87z5eLvsG1NlTZRwDLEznF'
      key: '6LcBx18tAAAAAIRbvC-leQ5rRLDIIuBBUDjVosAx'
    };

    $scope.rememberMe = false;

    $scope.setResponse = function (response) {
      $scope.response = response;
    };

    $scope.setWidgetId = function (widgetId) {
      $scope.widgetId = widgetId;
    };

    var confirmService = crudService('registered_users', {
      'confirm': {
        method: 'POST',
        url: '/data/rest/registered_users/confirm'
      }
    });

    if ($routeParams.code) {
      confirmService.confirm({
        code: $routeParams.code
      }, function () {
        toaster.pop('success', $filter('translate')('generic.success'),
          $filter('translate')('eauction.user_confirmed'));
        $location.search('code', null);
      });
    }

    if ($routeParams.error) {
      toaster.pop('error', $filter('translate')('generic.error'),
        $filter('translate')($routeParams.error));
    }
    if ($routeParams.info) {
      toaster.pop('success', $filter('translate')('generic.success'),
        $filter('translate')($routeParams.info));
    }
    $scope.renewPassword = function () {

      UserService.passwordRenew({
        username: $scope.username
      }, function () {
        $location.path("/login");
        toaster.pop('success', $filter('translate')('generic.success'),
          $filter('translate')('generic.password_sent_via_email'));
      });

    };

    $scope.remindUsername = function () {

      UserService.remindUsername({
        email: $scope.email
      }, function () {
        $location.path("/login");
        toaster.pop('success', $filter('translate')('generic.success'),
          $filter('translate')('generic.username_sent_via_email'));
      });

    };



    $scope.recaptchaCounter = 0;

    $scope.submitLoginOnEnter = function ($event) {
      if ($event.keyCode === 13 || $event.which === 13 || $event.key === 'Enter') {
        $event.preventDefault();
        $scope.login();
      }
    };

    $scope.login = function () {


      // $scope.loginAttempts.$invalid = true;
      $scope.recaptchaCounter = $scope.recaptchaCounter + 1;
      // $scope.loginAttempts.$invalid=false;

      if ($scope.recaptchaCounter >= 3){
        if ($scope.loginAttempts && !$scope.loginAttempts.$invalid){
          $scope.recaptchaCounter = 0;
        }
      }

      if ($scope.recaptchaCounter < 3){
        if ($scope.loginAttempts) {
          $scope.loginAttempts.$invalid = true;
        }

      UserService.authenticate($.param({
        username: $scope.username,
        password: $scope.password,
        rememberMe: $scope.rememberMe
      }), function (authenticationResult) {
        if (authenticationResult.mfaRequired) {
          $cookieStore.put('mfaTempToken', authenticationResult.tempToken);
          $location.path('/login-mfa');
          return;
        }

        $rootScope.authToken = authenticationResult.token;

        $rootScope.loginAction = true;
        if (!$rootScope.system) {
          $rootScope.system = 'GENERAL';
        }
        Page.navigationBySystem({system: $rootScope.system}, function () {
          Auth.authenticate();

          if (authenticationResult.mfaSetupRequired) {
            $location.path('/user/profile');
            return;
          }

          if ($rootScope.returnPath && $rootScope.returnPath != "/login") {
          $location.path($rootScope.returnPath);
          delete $rootScope.returnPath;
        } else {

          userService.checkPasswordExpiration(function (isPasswordExpired) { //
            //debugger;
            if (isPasswordExpired.value === true) {
              localStorage.setItem('passwordExpiredMessage', $filter('translate')('Your password has expired. Please change it.'));
              $location.path("/user/profile");
              // };
            } else {
              $location.path("/");
            }
          }, function (error) {
            console.error('Error checking password expiration:', error); //
            $location.path("/");
            toaster.pop('error', $filter('translate')('generic.error'),
              $filter('translate')('An error occurred during password check.')); //
          });
        }
        });
      }, function (conf) {

        if (conf.status === 401) {

          toaster.pop('error', $filter('translate')('generic.login_error'),
            $filter('translate')('generic.invalid_username_or_password'));
        }
      });
    } else {
        toaster.pop('error', $filter('translate')('generic.login_error'),
          $filter('translate')('generic.captcha_error'));
      }
    };



  }
]);
